import script from "./SocialModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SocialModal.vue?vue&type=script&lang=ts&setup=true"

import "./SocialModal.vue?vue&type=style&index=0&id=29e65061&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e65061"]])

export default __exports__